import { PropsWithChildren } from "react";
import Button from "@common/components/Button";
import Typography from "@common/components/Typography";
import { Box, SxProps, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import BookmarkIcon from "./BookmarkIcon";
import ItemButton from "./ItemButton";
import { Colors } from "./ItemButton";
import ListTypography from "../ListTypography";

interface ItemListButtonProps {
  label: string;
  ticketColor: Colors;
  ticketContent?: Number;
  displayTicket?: boolean;
  bookmark: boolean;
  iconBookmark?: React.JSX.Element;
  iconBookmarkChecked?: React.JSX.Element;
  minWidth?: string;
  onBookmarkClick?: Function;
  linkTo?: string;
  previousState?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ItemListButtonComputeStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  columnGap: "1rem",
  margin: "0.5rem 1.5rem 0.5rem 0.5rem",
  width: "100%",
};

const ItemListButton = (props: PropsWithChildren<ItemListButtonProps>) => {
  const {
    label,
    ticketColor,
    ticketContent,
    iconBookmark,
    iconBookmarkChecked,
    minWidth = "20rem",
    onBookmarkClick,
    linkTo,
    previousState,
    bookmark,
    displayTicket = true,
    onClick,
    disabled = false,
  } = props;
  const changeState = () => {
    onBookmarkClick && onBookmarkClick(!bookmark);
  };
  const btnSx: SxProps = {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    "& .MuiTypography-root": {
      position: "absolute",
      top: "50%",
      left: "0",
      right: "0",
      transform: "translateY(-50%)",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      padding: "0 10px",
    },
  };

  return (
    <Box
      sx={[{
        minWidth: minWidth
      }, ItemListButtonComputeStyle]}>
      {iconBookmark && (
        <BookmarkIcon
          icon={iconBookmark}
          checkedIcon={iconBookmarkChecked}
          state={bookmark}
          changeState={changeState}
        />
      )}
      {displayTicket && (
        <Link
          to={linkTo ? `${linkTo}?tab=Tickets&status=Open` : "#"}
          state={{ previous: previousState }}
          style={{
            color: "inherit",
            textDecoration: "inherit",
          }}
        >
          <Tooltip title={label} arrow disableInteractive>
            <ItemButton color={ticketColor} width="3rem">
              <Typography size="small" variant="caption">
                {`${ticketContent ?? 0}`}
              </Typography>
            </ItemButton>
          </Tooltip>
        </Link>
      )}
      {linkTo !== undefined ? (
        <Link
          to={linkTo}
          state={{ previous: previousState }}
          style={{
            display: "flex",
            flex: "1",
            textDecoration: "none",
          }}
        >
          <Tooltip title={label} arrow disableInteractive>
            <Button
              ignoreLocalization
              sx={btnSx}
              disabled={disabled}
              variant="outlined"
            >
              {label}
            </Button>
          </Tooltip>
        </Link>
      ) : onClick !== undefined ? (
        <div
          style={{
            display: "flex",
            flex: "1",
            textDecoration: "none",
          }}
        >
          <Tooltip title={label} arrow disableInteractive>
            <Button
              variant="outlined"
              onClick={onClick}
              ignoreLocalization
              sx={btnSx}
              disabled={disabled}
            >
              {label}
            </Button>
          </Tooltip>
        </div>
      ) : (
        <ListTypography cellValue={label} />
      )}
    </Box>
  );
};

export default ItemListButton;
